import type { ReactNode } from "react";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";

export interface DesktopTopBarProps {
  search?: ReactNode;
  menu?: ReactNode;
}

export const DesktopTopBar = ({ search, menu }: DesktopTopBarProps) => {
  return search || menu ? (
    <AppBar
      elevation={0}
      variant="outlined"
      color="transparent"
      position="relative"
      id="page-top-bar"
      sx={{
        border: "none",
        paddingY: {
          xs: 2.5,
          sm: 3,
        },
        "& > div": {
          minHeight: "auto",
        },
      }}>
      <Container
        sx={{
          px: "0 !important",
          display: "flex",
          justifyContent: "space-between",
        }}
        component={(props) => <Toolbar {...props} />}>
        <Box
          sx={{
            display: "inline-block",
          }}>
          {search}
        </Box>
        <Box
          sx={{
            display: "inline-block",
            alignSelf: "right",
          }}>
          {menu}
        </Box>
      </Container>
    </AppBar>
  ) : null;
};
